import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import qs from 'querystring'; // client js begin

import EasyStore from './easy-store';
import util from './index';
var store = new EasyStore('cloud_seal_store', 'local'); // client js end

var expires = 3 * 60 * 1000; // 前端存三分钟

/** *
 * 获取服务端渲染图片
 * @param url
 * @param query
 * @returns {Promise<unknown>}
 */

export function getCardImg(_ref) {
  var _ref$url = _ref.url,
      url = _ref$url === void 0 ? '/cgi/card/getCardImgById' : _ref$url,
      _ref$query = _ref.query,
      query = _ref$query === void 0 ? {} : _ref$query;
  return new Promise(function (resolve, reject) {
    var timer = setTimeout(reject, 3000);
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.send(qs.stringify(query));

    xhr.onreadystatechange = function () {
      var json = util.parseJson(xhr.responseText);

      if (xhr.readyState === 4) {
        clearTimeout(timer);

        if (xhr.status === 200) {
          resolve(json.data);
        } else {
          reject(json);
        }
      }
    };
  });
}
/** *
 * 获取卡片信息
 * @param url
 * @param query
 * @param retry
 * @param useCache
 * @param reportInstance
 * @returns {Promise<unknown>}
 */

export function getCardData(_ref2) {
  var _ref2$url = _ref2.url,
      url = _ref2$url === void 0 ? '' : _ref2$url,
      _ref2$query = _ref2.query,
      query = _ref2$query === void 0 ? {} : _ref2$query,
      _ref2$retry = _ref2.retry,
      retry = _ref2$retry === void 0 ? 3 : _ref2$retry,
      _ref2$useCache = _ref2.useCache,
      useCache = _ref2$useCache === void 0 ? true : _ref2$useCache,
      reportInstance = _ref2.reportInstance;
  // 预览的不走缓存
  var totalTryCount = retry;
  var tryCount = retry;
  var isPreview = query.version || query.env;

  if (!isPreview) {
    var storeData = store.get(query.id);

    if (storeData) {
      console.log('get data from cache.', storeData);
      reportInstance && reportInstance.setReportData('getCardDataReTryCount', 0); // 上报

      return Promise.resolve(storeData);
    }
  }

  var fetchData = function fetchData(resolve, reject) {
    tryCount -= 1;
    return util.getJSON("".concat(url, "?").concat(qs.stringify(query))).then(function (res) {
      if (res.code === 0 && res.data) {
        var cardData = res.data;
        useCache && store.set(cardData.id, cardData, expires); // 存进去

        reportInstance && reportInstance.setReportData('getCardDataReTryCount', totalTryCount - tryCount - 1); // 上报

        return resolve(cardData);
      }

      return Promise.reject(res);
    }).catch(function (e) {
      // code -2001 card not exit
      if (tryCount >= 0 && e.code !== -2001) {
        return fetchData(resolve, reject);
      }

      reportInstance && reportInstance.setReportData('getCardDataReTryCount', totalTryCount - tryCount - 1); // 上报

      reject(e);
    });
  };

  return new Promise(fetchData);
}